import { Dispatch, SetStateAction } from "react";
import {
  Modal,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddFikraStep({ open, onClose, setOpen }: ModalProps) {

  return (
    <Modal className="modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">

          {/* Header */}
          <div className="modal_title">
            <h2>Step 1 Question Detail</h2>
            <button
              className="btn-close"
              onClick={() => setOpen(false)}
            >
              <CloseIcon />
            </button>
          </div>

          <div className="fikra_ques_detail">
            <h3>What are you passionate about?</h3>
            <p>Select categories that interest you. We'll find businesses you'll love.</p>

            <div className="field_list">
              <div className="field_list_item">
                <figure>👗</figure>
                <p>
                  <strong>Fashion &amp; Apparel</strong>
                  <span>Clothing, accessories, modest wear</span>
                </p>
              </div>
              <div className="field_list_item">
                <figure>💄</figure>
                <p>
                  <strong>Beauty & Wellness</strong>
                  <span>Skincare, cosmetics, spa services</span>
                </p>
              </div>
              <div className="field_list_item">
                <figure>🍽️</figure>
                <p>
                  <strong>Food & Culinary</strong>
                  <span>Snacks, catering, specialty foods</span>
                </p>
              </div>
              <div className="field_list_item">
                <figure>🏠</figure>
                <p>
                  <strong>Home & Decor</strong>
                  <span>Furniture, art, home accessories</span>
                </p>
              </div>
              <div className="field_list_item">
                <figure>🎨</figure>
                <p>
                  <strong>Handmade & Crafts</strong>
                  <span>DIY, custom art, handmade goods</span>
                </p>
              </div>
              <div className="field_list_item">
                <figure>📱</figure>
                <p>
                  <strong>Technology</strong>
                  <span>Gadgets, apps, smart devices</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
